export default "__VITE_ASSET__60Lbiwq5__"